import PropTypes from 'prop-types'

const ObservianLogoGateMSFT = ({ className, firstSpin, secondSpin }) => (
  <svg
    viewBox="0 0 1135 1135"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className={className}
  >
    <defs>
      <linearGradient
        x1="15.4356061%"
        y1="90.5184659%"
        x2="114.318971%"
        y2="21.4133523%"
        id="linearGradient-1"
      >
        <stop stopColor="#008AD7" offset="0%" />
        <stop stopColor="#008CDA" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="19.0171813%"
        y1="84.9243045%"
        x2="81.2706739%"
        y2="16.3295925%"
        id="linearGradient-2"
      >
        <stop stopColor="#1D8DBA" offset="0%" />
        <stop stopColor="#03ECAE" offset="100%" />
      </linearGradient>
    </defs>
    <g id="Azure" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Artboard" transform="translate(-441.000000, -140.000000)">
        <g id="Group-20" transform="translate(547.000000, 246.000000)">
          <path
            d="M461,666 C574.218374,666 666,574.218374 666,461 C666,347.781626 574.218374,256 461,256 C347.781626,256 256,347.781626 256,461 C256,574.218374 347.781626,666 461,666 Z"
            stroke="url(#linearGradient-1)"
            strokeWidth="93.75"
            opacity="0.0369001116"
            strokeLinejoin="round"
            strokeDasharray="62.5,3.125"
            className={firstSpin}
          />
          <path
            d="M461.5,923 C716.379412,923 923,716.379412 923,461.5 C923,206.620588 716.379412,0 461.5,0 C206.620588,0 0,206.620588 0,461.5 C0,716.379412 206.620588,923 461.5,923 Z"
            stroke="url(#linearGradient-1)"
            strokeWidth="210.9375"
            opacity="0.0369001116"
            strokeLinejoin="round"
            strokeDasharray="140.625,7.03125"
            className={secondSpin}
          />
          <path
            d="M514.286059,430.393844 L514.286059,475.711181 C514.291884,479.675532 512.181216,483.340937 508.751163,485.32311 L462.534884,512.053691 C459.109886,514.032949 454.890114,514.032949 451.465116,512.053691 L405.248837,485.32311 C401.818784,483.340937 399.708116,479.675532 399.713755,475.711181 L399.713755,430.393844 C399.701254,429.259375 400.297554,428.205281 401.276015,427.632551 C402.254476,427.059821 403.46469,427.056494 404.446279,427.623835 L452.821163,455.60092 C454.092037,456.339445 455.530667,456.739965 457,456.764324 C458.478177,456.767326 459.930352,456.375257 461.206512,455.62862 L509.581395,427.651535 C510.556926,427.100858 511.75101,427.109129 512.718833,427.673266 C513.686657,428.237404 514.283126,429.272834 514.286059,430.393844 Z M413.495814,407.845975 L451.465116,385.935209 C454.890114,383.955951 459.109886,383.955951 462.534884,385.935209 L500.448837,407.845975 C501.460113,408.400018 502.088941,409.46206 502.088941,410.615984 C502.088941,411.769907 501.460113,412.831949 500.448837,413.385992 L457,438.426868 L413.495814,413.302892 C412.525795,412.737185 411.929198,411.698136 411.929198,410.574434 C411.929198,409.450731 412.525795,408.411683 413.495814,407.845975 Z M460.542326,331.532244 L543.897674,379.67499 C554.77103,385.958528 561.461861,397.577992 561.443256,410.145082 L561.443256,490.475326 C561.461861,503.042417 554.77103,514.66188 543.897674,520.945418 L474.517907,560.778139 C463.652101,567.057333 450.264876,567.057333 439.39907,560.778139 L370.046977,520.696118 C359.173621,514.412579 352.48279,502.793116 352.501395,490.226025 L352.501395,394.356034 C352.503969,391.769019 351.120103,389.379372 348.876047,388.095815 L348.876047,388.095815 C346.636517,386.801603 343.877846,386.799224 341.636091,388.089571 C339.394337,389.379918 338.008861,391.767655 338,394.356034 L338,490.281425 C338.027706,508.037729 347.523843,524.428476 362.906977,533.271956 L432.093023,573.353977 C447.438542,582.215341 466.340063,582.215341 481.685581,573.353977 L551.093023,533.271956 C566.480336,524.432677 575.978013,508.039273 576,490.281425 L576,410.089682 C575.932498,392.34415 566.447051,375.971853 551.093023,367.099152 L467.848372,318.956406 C465.606297,317.673874 462.851931,317.681728 460.617192,318.977024 C458.382454,320.27232 457.00466,322.659544 457,325.244325 L457,325.244325 C456.993278,327.832452 458.364081,330.228306 460.597674,331.532244 L460.542326,331.532244 Z M390.083256,496.347744 C385.678923,493.795948 382.968105,489.087208 382.97093,483.993506 L382.97093,414.937197 C382.960817,409.84879 385.674918,405.144919 390.083256,402.610659 L449.943023,367.847054 C454.342611,365.297981 459.768087,365.297981 464.167674,367.847054 L524.027442,402.499859 C528.461812,405.062226 531.178165,409.812318 531.139767,414.937197 L531.139767,487.345216 C531.14445,489.93752 532.525039,492.332057 534.765116,493.633136 L534.765116,493.633136 C537.005567,494.870028 539.730339,494.838559 541.94168,493.550251 C544.153021,492.261944 545.526105,489.906039 545.558143,487.345216 L545.558143,414.937197 C545.562968,404.655836 540.087932,395.152749 531.195116,390.007121 L471.418372,355.354316 C462.527454,350.229543 451.583244,350.229543 442.692326,355.354316 L382.832558,390.007121 C373.92909,395.145708 368.441845,404.650121 368.441845,414.937197 L368.441845,484.187407 C368.431317,494.470297 373.907883,503.97604 382.804884,509.117483 L446.179302,545.515393 C448.419593,546.783896 451.163835,546.768529 453.389805,545.475015 C455.615776,544.181502 456.989778,541.803753 457,539.227474 L457,539.227474 C457.001002,536.633644 455.618893,534.23647 453.374651,532.939555 L390.083256,496.347744 Z"
            id="Shape"
            fill="url(#linearGradient-2)"
            fillRule="nonzero"
            opacity="0.0678013393"
          />
        </g>
      </g>
    </g>
  </svg>
)

ObservianLogoGateMSFT.defaultProps = {
  className: '',
  firstSpin: '',
  secondSpin: '',
}

ObservianLogoGateMSFT.propTypes = {
  className: PropTypes.string,
  firstSpin: PropTypes.string,
  secondSpin: PropTypes.string,
}

export default ObservianLogoGateMSFT
